// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file gitpod/v1/prebuild.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import { file_gitpod_tools_v1_logfields } from "../tools/v1/logfields_pb";
import { file_gitpod_tools_v1_stainless } from "../tools/v1/stainless_pb";
import type { Subject } from "./identity_pb";
import { file_gitpod_v1_identity } from "./identity_pb";
import type { PaginationRequest, PaginationResponse } from "./pagination_pb";
import { file_gitpod_v1_pagination } from "./pagination_pb";
import type { Duration, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_duration, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file gitpod/v1/prebuild.proto.
 */
export const file_gitpod_v1_prebuild: GenFile = /*@__PURE__*/
  fileDesc("ChhnaXRwb2QvdjEvcHJlYnVpbGQucHJvdG8SCWdpdHBvZC52MSLXAQoVQ3JlYXRlUHJlYnVpbGRSZXF1ZXN0Ei8KCnByb2plY3RfaWQYASABKAlCG7pICMgBAXIDsAEBoqseDAoKcHJvamVjdC5pZBJFChRlbnZpcm9ubWVudF9jbGFzc19pZBgCIAEoCUIiukgFcgOwAQGiqx4WChRlbnZpcm9ubWVudF9jbGFzcy5pZEgAiAEBEi0KBHNwZWMYAyABKAsyFy5naXRwb2QudjEuUHJlYnVpbGRTcGVjQga6SAPIAQFCFwoVX2Vudmlyb25tZW50X2NsYXNzX2lkIkcKFkNyZWF0ZVByZWJ1aWxkUmVzcG9uc2USLQoIcHJlYnVpbGQYASABKAsyEy5naXRwb2QudjEuUHJlYnVpbGRCBrpIA8gBASKCBAoUTGlzdFByZWJ1aWxkc1JlcXVlc3QSMAoKcGFnaW5hdGlvbhgBIAEoCzIcLmdpdHBvZC52MS5QYWdpbmF0aW9uUmVxdWVzdBI2CgZmaWx0ZXIYAiABKAsyJi5naXRwb2QudjEuTGlzdFByZWJ1aWxkc1JlcXVlc3QuRmlsdGVyGv8CCgZGaWx0ZXISPAoLcHJvamVjdF9pZHMYASADKAlCJ7pIDJIBCRAZIgVyA7ABAaKrHhQKEmZpbHRlci5wcm9qZWN0X2lkcxJMCgZwaGFzZXMYAiADKA4yGC5naXRwb2QudjEuUHJlYnVpbGRQaGFzZUIiukgMkgEJEAoiBYIBAhABoqseDwoNZmlsdGVyLnBoYXNlcxJrCgx0cmlnZ2VyZWRfYnkYAyADKA4yKy5naXRwb2QudjEuUHJlYnVpbGRNZXRhZGF0YS5QcmVidWlsZFRyaWdnZXJCKLpIDJIBCRAFIgWCAQIQAaKrHhUKE2ZpbHRlci50cmlnZ2VyZWRfYnkSPAoLY3JlYXRvcl9pZHMYBCADKAlCJ7pIDJIBCRAZIgVyA7ABAaKrHhQKEmZpbHRlci5jcmVhdG9yX2lkcxI+CgxleGVjdXRvcl9pZHMYBSADKAlCKLpIDJIBCRAZIgVyA7ABAaKrHhUKE2ZpbHRlci5leGVjdXRvcl9pZHMicgoVTGlzdFByZWJ1aWxkc1Jlc3BvbnNlEjEKCnBhZ2luYXRpb24YASABKAsyHS5naXRwb2QudjEuUGFnaW5hdGlvblJlc3BvbnNlEiYKCXByZWJ1aWxkcxgCIAMoCzITLmdpdHBvZC52MS5QcmVidWlsZCJHChJHZXRQcmVidWlsZFJlcXVlc3QSMQoLcHJlYnVpbGRfaWQYASABKAlCHLpICMgBAXIDsAEBoqseDQoLcHJlYnVpbGQuaWQiRAoTR2V0UHJlYnVpbGRSZXNwb25zZRItCghwcmVidWlsZBgBIAEoCzITLmdpdHBvZC52MS5QcmVidWlsZEIGukgDyAEBIkoKFUNhbmNlbFByZWJ1aWxkUmVxdWVzdBIxCgtwcmVidWlsZF9pZBgBIAEoCUIcukgIyAEBcgOwAQGiqx4NCgtwcmVidWlsZC5pZCJHChZDYW5jZWxQcmVidWlsZFJlc3BvbnNlEi0KCHByZWJ1aWxkGAEgASgLMhMuZ2l0cG9kLnYxLlByZWJ1aWxkQga6SAPIAQEiSgoVRGVsZXRlUHJlYnVpbGRSZXF1ZXN0EjEKC3ByZWJ1aWxkX2lkGAEgASgJQhy6SAjIAQFyA7ABAaKrHg0KC3ByZWJ1aWxkLmlkIhgKFkRlbGV0ZVByZWJ1aWxkUmVzcG9uc2UiUwoeQ3JlYXRlUHJlYnVpbGRMb2dzVG9rZW5SZXF1ZXN0EjEKC3ByZWJ1aWxkX2lkGAEgASgJQhy6SAjIAQFyA7ABAaKrHg0KC3ByZWJ1aWxkLmlkIj8KH0NyZWF0ZVByZWJ1aWxkTG9nc1Rva2VuUmVzcG9uc2USHAoMYWNjZXNzX3Rva2VuGAEgASgJQga6SAPIAQEiygEKCFByZWJ1aWxkEiUKAmlkGAEgASgJQhm6SAVyA7ABAaKrHg0KC3ByZWJ1aWxkLmlkEjUKCG1ldGFkYXRhGAIgASgLMhsuZ2l0cG9kLnYxLlByZWJ1aWxkTWV0YWRhdGFCBrpIA8gBARItCgRzcGVjGAMgASgLMhcuZ2l0cG9kLnYxLlByZWJ1aWxkU3BlY0IGukgDyAEBEjEKBnN0YXR1cxgEIAEoCzIZLmdpdHBvZC52MS5QcmVidWlsZFN0YXR1c0IGukgDyAEBIrwEChBQcmVidWlsZE1ldGFkYXRhEjYKD29yZ2FuaXphdGlvbl9pZBgBIAEoCUIdukgFcgOwAQGiqx4RCg9vcmdhbml6YXRpb24uaWQSLAoKcHJvamVjdF9pZBgCIAEoCUIYukgFcgOwAQGiqx4MCgpwcm9qZWN0LmlkEkAKFGVudmlyb25tZW50X2NsYXNzX2lkGAMgASgJQiK6SAVyA7ABAaKrHhYKFGVudmlyb25tZW50X2NsYXNzLmlkEisKB2NyZWF0b3IYBCABKAsyEi5naXRwb2QudjEuU3ViamVjdEIGukgDyAEBEjYKCmNyZWF0ZWRfYXQYBSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wQga6SAPIAQESNgoKdXBkYXRlZF9hdBgGIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBCBrpIA8gBARJLCgx0cmlnZ2VyZWRfYnkYByABKA4yKy5naXRwb2QudjEuUHJlYnVpbGRNZXRhZGF0YS5QcmVidWlsZFRyaWdnZXJCCLpIBYIBAhABEiQKCGV4ZWN1dG9yGAggASgLMhIuZ2l0cG9kLnYxLlN1YmplY3QicAoPUHJlYnVpbGRUcmlnZ2VyEiAKHFBSRUJVSUxEX1RSSUdHRVJfVU5TUEVDSUZJRUQQABIbChdQUkVCVUlMRF9UUklHR0VSX01BTlVBTBABEh4KGlBSRUJVSUxEX1RSSUdHRVJfU0NIRURVTEVEEAIinQEKDFByZWJ1aWxkU3BlYxIUCgxzcGVjX3ZlcnNpb24YASABKAQSOQoNZGVzaXJlZF9waGFzZRgCIAEoDjIYLmdpdHBvZC52MS5QcmVidWlsZFBoYXNlQgi6SAWCAQIQARI8Cgd0aW1lb3V0GAMgASgLMhkuZ29vZ2xlLnByb3RvYnVmLkR1cmF0aW9uQhC6SA2qAQoiAwigODIDCKwCIuYCCg5QcmVidWlsZFN0YXR1cxI0CgVwaGFzZRgBIAEoDjIYLmdpdHBvZC52MS5QcmVidWlsZFBoYXNlQgu6SAjIAQGCAQIQARIzCg9jb21wbGV0aW9uX3RpbWUYAiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEhcKD2ZhaWx1cmVfbWVzc2FnZRgDIAEoCRIZCgdsb2dfdXJsGAQgASgJQgi6SAVyA4gBARI0Cg5lbnZpcm9ubWVudF9pZBgFIAEoCUIcukgFcgOwAQGiqx4QCg5lbnZpcm9ubWVudC5pZBIWCg5zdGF0dXNfdmVyc2lvbhgGIAEoBBIXCg93YXJuaW5nX21lc3NhZ2UYByABKAkSMQoec25hcHNob3RfY29tcGxldGlvbl9wZXJjZW50YWdlGAggASgFQgm6SAYaBBhkKAASGwoTc25hcHNob3Rfc2l6ZV9ieXRlcxgJIAEoAyKOAgoVQ3JlYXRlV2FybVBvb2xSZXF1ZXN0Ei8KCnByb2plY3RfaWQYASABKAlCG7pICMgBAXIDsAEBoqseDAoKcHJvamVjdC5pZBJDChRlbnZpcm9ubWVudF9jbGFzc19pZBgCIAEoCUIlukgIyAEBcgOwAQGiqx4WChRlbnZpcm9ubWVudF9jbGFzcy5pZBIhCgxkZXNpcmVkX3NpemUYAyABKAVCCxgBukgGGgQYFCgBEiAKCG1pbl9zaXplGAQgASgFQgm6SAYaBBgUKABIAIgBARIgCghtYXhfc2l6ZRgFIAEoBUIJukgGGgQYFCgBSAGIAQFCCwoJX21pbl9zaXplQgsKCV9tYXhfc2l6ZSJIChZDcmVhdGVXYXJtUG9vbFJlc3BvbnNlEi4KCXdhcm1fcG9vbBgBIAEoCzITLmdpdHBvZC52MS5XYXJtUG9vbEIGukgDyAEBIkkKEkdldFdhcm1Qb29sUmVxdWVzdBIzCgx3YXJtX3Bvb2xfaWQYASABKAlCHbpICMgBAXIDsAEBoqseDgoMd2FybV9wb29sLmlkIkUKE0dldFdhcm1Qb29sUmVzcG9uc2USLgoJd2FybV9wb29sGAEgASgLMhMuZ2l0cG9kLnYxLldhcm1Qb29sQga6SAPIAQEimwIKFExpc3RXYXJtUG9vbHNSZXF1ZXN0EjAKCnBhZ2luYXRpb24YASABKAsyHC5naXRwb2QudjEuUGFnaW5hdGlvblJlcXVlc3QSNgoGZmlsdGVyGAIgASgLMiYuZ2l0cG9kLnYxLkxpc3RXYXJtUG9vbHNSZXF1ZXN0LkZpbHRlchqYAQoGRmlsdGVyEjwKC3Byb2plY3RfaWRzGAEgAygJQie6SAySAQkQGSIFcgOwAQGiqx4UChJmaWx0ZXIucHJvamVjdF9pZHMSUAoVZW52aXJvbm1lbnRfY2xhc3NfaWRzGAIgAygJQjG6SAySAQkQGSIFcgOwAQGiqx4eChxmaWx0ZXIuZW52aXJvbm1lbnRfY2xhc3NfaWRzInMKFUxpc3RXYXJtUG9vbHNSZXNwb25zZRIxCgpwYWdpbmF0aW9uGAEgASgLMh0uZ2l0cG9kLnYxLlBhZ2luYXRpb25SZXNwb25zZRInCgp3YXJtX3Bvb2xzGAIgAygLMhMuZ2l0cG9kLnYxLldhcm1Qb29sIuMBChVVcGRhdGVXYXJtUG9vbFJlcXVlc3QSMwoMd2FybV9wb29sX2lkGAEgASgJQh26SAjIAQFyA7ABAaKrHg4KDHdhcm1fcG9vbC5pZBImCgxkZXNpcmVkX3NpemUYAiABKAVCCxgBukgGGgQYFCgBSACIAQESIAoIbWluX3NpemUYAyABKAVCCbpIBhoEGBQoAEgBiAEBEiAKCG1heF9zaXplGAQgASgFQgm6SAYaBBgUKAFIAogBAUIPCg1fZGVzaXJlZF9zaXplQgsKCV9taW5fc2l6ZUILCglfbWF4X3NpemUiSAoWVXBkYXRlV2FybVBvb2xSZXNwb25zZRIuCgl3YXJtX3Bvb2wYASABKAsyEy5naXRwb2QudjEuV2FybVBvb2xCBrpIA8gBASJMChVEZWxldGVXYXJtUG9vbFJlcXVlc3QSMwoMd2FybV9wb29sX2lkGAEgASgJQh26SAjIAQFyA7ABAaKrHg4KDHdhcm1fcG9vbC5pZCIYChZEZWxldGVXYXJtUG9vbFJlc3BvbnNlIssBCghXYXJtUG9vbBImCgJpZBgBIAEoCUIaukgFcgOwAQGiqx4OCgx3YXJtX3Bvb2wuaWQSNQoIbWV0YWRhdGEYAiABKAsyGy5naXRwb2QudjEuV2FybVBvb2xNZXRhZGF0YUIGukgDyAEBEi0KBHNwZWMYAyABKAsyFy5naXRwb2QudjEuV2FybVBvb2xTcGVjQga6SAPIAQESMQoGc3RhdHVzGAQgASgLMhkuZ2l0cG9kLnYxLldhcm1Qb29sU3RhdHVzQga6SAPIAQEi1gIKEFdhcm1Qb29sTWV0YWRhdGESNgoPb3JnYW5pemF0aW9uX2lkGAEgASgJQh26SAVyA7ABAaKrHhEKD29yZ2FuaXphdGlvbi5pZBIsCgpwcm9qZWN0X2lkGAIgASgJQhi6SAVyA7ABAaKrHgwKCnByb2plY3QuaWQSQAoUZW52aXJvbm1lbnRfY2xhc3NfaWQYAyABKAlCIrpIBXIDsAEBoqseFgoUZW52aXJvbm1lbnRfY2xhc3MuaWQSKgoJcnVubmVyX2lkGAQgASgJQhe6SAVyA7ABAaKrHgsKCXJ1bm5lci5pZBI2CgpjcmVhdGVkX2F0GAUgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEIGukgDyAEBEjYKCnVwZGF0ZWRfYXQYBiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wQga6SAPIAQEiqAIKDFdhcm1Qb29sU3BlYxIUCgxzcGVjX3ZlcnNpb24YASABKAQSIQoMZGVzaXJlZF9zaXplGAIgASgFQgsYAbpIBhoEGBQoARI2CgtzbmFwc2hvdF9pZBgDIAEoCUIcukgI2AEBcgOwAQGiqx4NCgtzbmFwc2hvdC5pZEgAiAEBEjkKDWRlc2lyZWRfcGhhc2UYBCABKA4yGC5naXRwb2QudjEuV2FybVBvb2xQaGFzZUIIukgFggECEAESIAoIbWluX3NpemUYBSABKAVCCbpIBhoEGBQoAEgBiAEBEiAKCG1heF9zaXplGAYgASgFQgm6SAYaBBgUKAFIAogBAUIOCgxfc25hcHNob3RfaWRCCwoJX21pbl9zaXplQgsKCV9tYXhfc2l6ZSLDAQoOV2FybVBvb2xTdGF0dXMSNAoFcGhhc2UYASABKA4yGC5naXRwb2QudjEuV2FybVBvb2xQaGFzZUILukgIyAEBggECEAESFwoPZmFpbHVyZV9tZXNzYWdlGAIgASgJEhYKDnN0YXR1c192ZXJzaW9uGAMgASgEEhkKEXJ1bm5pbmdfaW5zdGFuY2VzGAQgASgFEhkKEXN0b3BwZWRfaW5zdGFuY2VzGAUgASgFEhQKDGRlc2lyZWRfc2l6ZRgGIAEoBSqCAwoNUHJlYnVpbGRQaGFzZRIeChpQUkVCVUlMRF9QSEFTRV9VTlNQRUNJRklFRBAAEhoKFlBSRUJVSUxEX1BIQVNFX1BFTkRJTkcQChIbChdQUkVCVUlMRF9QSEFTRV9TVEFSVElORxAUEhoKFlBSRUJVSUxEX1BIQVNFX1JVTk5JTkcQHhIbChdQUkVCVUlMRF9QSEFTRV9TVE9QUElORxAoEh8KG1BSRUJVSUxEX1BIQVNFX1NOQVBTSE9UVElORxAyEhwKGFBSRUJVSUxEX1BIQVNFX0NPTVBMRVRFRBA8EhkKFVBSRUJVSUxEX1BIQVNFX0ZBSUxFRBBGEh0KGVBSRUJVSUxEX1BIQVNFX0NBTkNFTExJTkcQSxIcChhQUkVCVUlMRF9QSEFTRV9DQU5DRUxMRUQQUBIbChdQUkVCVUlMRF9QSEFTRV9ERUxFVElORxBVEhoKFlBSRUJVSUxEX1BIQVNFX0RFTEVURUQQWhoPwqseCwoJcHJlYnVpbGRzKtIBCg1XYXJtUG9vbFBoYXNlEh8KG1dBUk1fUE9PTF9QSEFTRV9VTlNQRUNJRklFRBAAEhsKF1dBUk1fUE9PTF9QSEFTRV9QRU5ESU5HEAoSGQoVV0FSTV9QT09MX1BIQVNFX1JFQURZEBQSHAoYV0FSTV9QT09MX1BIQVNFX0RFR1JBREVEEB4SHAoYV0FSTV9QT09MX1BIQVNFX0RFTEVUSU5HECgSGwoXV0FSTV9QT09MX1BIQVNFX0RFTEVURUQQMhoPwqseCwoJcHJlYnVpbGRzMscJCg9QcmVidWlsZFNlcnZpY2USYwoOQ3JlYXRlUHJlYnVpbGQSIC5naXRwb2QudjEuQ3JlYXRlUHJlYnVpbGRSZXF1ZXN0GiEuZ2l0cG9kLnYxLkNyZWF0ZVByZWJ1aWxkUmVzcG9uc2UiDLKrHggSBmNyZWF0ZRJhCg1MaXN0UHJlYnVpbGRzEh8uZ2l0cG9kLnYxLkxpc3RQcmVidWlsZHNSZXF1ZXN0GiAuZ2l0cG9kLnYxLkxpc3RQcmVidWlsZHNSZXNwb25zZSINkAIBsqseBhIEbGlzdBJfCgtHZXRQcmVidWlsZBIdLmdpdHBvZC52MS5HZXRQcmVidWlsZFJlcXVlc3QaHi5naXRwb2QudjEuR2V0UHJlYnVpbGRSZXNwb25zZSIRkAIBsqseChIIcmV0cmlldmUSYwoOQ2FuY2VsUHJlYnVpbGQSIC5naXRwb2QudjEuQ2FuY2VsUHJlYnVpbGRSZXF1ZXN0GiEuZ2l0cG9kLnYxLkNhbmNlbFByZWJ1aWxkUmVzcG9uc2UiDLKrHggSBmNhbmNlbBJjCg5EZWxldGVQcmVidWlsZBIgLmdpdHBvZC52MS5EZWxldGVQcmVidWlsZFJlcXVlc3QaIS5naXRwb2QudjEuRGVsZXRlUHJlYnVpbGRSZXNwb25zZSIMsqseCBIGZGVsZXRlEokBChdDcmVhdGVQcmVidWlsZExvZ3NUb2tlbhIpLmdpdHBvZC52MS5DcmVhdGVQcmVidWlsZExvZ3NUb2tlblJlcXVlc3QaKi5naXRwb2QudjEuQ3JlYXRlUHJlYnVpbGRMb2dzVG9rZW5SZXNwb25zZSIXsqseExIRY3JlYXRlX2xvZ3NfdG9rZW4SbQoOQ3JlYXRlV2FybVBvb2wSIC5naXRwb2QudjEuQ3JlYXRlV2FybVBvb2xSZXF1ZXN0GiEuZ2l0cG9kLnYxLkNyZWF0ZVdhcm1Qb29sUmVzcG9uc2UiFrKrHhISEGNyZWF0ZV93YXJtX3Bvb2wSaQoLR2V0V2FybVBvb2wSHS5naXRwb2QudjEuR2V0V2FybVBvb2xSZXF1ZXN0Gh4uZ2l0cG9kLnYxLkdldFdhcm1Qb29sUmVzcG9uc2UiG5ACAbKrHhQSEnJldHJpZXZlX3dhcm1fcG9vbBJsCg1MaXN0V2FybVBvb2xzEh8uZ2l0cG9kLnYxLkxpc3RXYXJtUG9vbHNSZXF1ZXN0GiAuZ2l0cG9kLnYxLkxpc3RXYXJtUG9vbHNSZXNwb25zZSIYkAIBsqseERIPbGlzdF93YXJtX3Bvb2xzEm0KDlVwZGF0ZVdhcm1Qb29sEiAuZ2l0cG9kLnYxLlVwZGF0ZVdhcm1Qb29sUmVxdWVzdBohLmdpdHBvZC52MS5VcGRhdGVXYXJtUG9vbFJlc3BvbnNlIhayqx4SEhB1cGRhdGVfd2FybV9wb29sEm0KDkRlbGV0ZVdhcm1Qb29sEiAuZ2l0cG9kLnYxLkRlbGV0ZVdhcm1Qb29sUmVxdWVzdBohLmdpdHBvZC52MS5EZWxldGVXYXJtUG9vbFJlc3BvbnNlIhayqx4SEhBkZWxldGVfd2FybV9wb29sGg+qqx4LCglwcmVidWlsZHNCLFoqZ2l0aHViLmNvbS9naXRwb2QtaW8vZ2l0cG9kLW5leHQvYXBpL2dvL3YxYgZwcm90bzM", [file_buf_validate_validate, file_gitpod_tools_v1_logfields, file_gitpod_tools_v1_stainless, file_gitpod_v1_identity, file_gitpod_v1_pagination, file_google_protobuf_duration, file_google_protobuf_timestamp]);

/**
 * @generated from message gitpod.v1.CreatePrebuildRequest
 */
export type CreatePrebuildRequest = Message<"gitpod.v1.CreatePrebuildRequest"> & {
  /**
   * project_id specifies the project to create a prebuild for
   *
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * environment_class_id specifies which environment class to use for the prebuild.
   * If not specified, uses the project's default environment class.
   *
   * @generated from field: optional string environment_class_id = 2;
   */
  environmentClassId?: string;

  /**
   * spec contains the configuration for creating the prebuild
   *
   * @generated from field: gitpod.v1.PrebuildSpec spec = 3;
   */
  spec?: PrebuildSpec;
};

/**
 * Describes the message gitpod.v1.CreatePrebuildRequest.
 * Use `create(CreatePrebuildRequestSchema)` to create a new message.
 */
export const CreatePrebuildRequestSchema: GenMessage<CreatePrebuildRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_prebuild, 0);

/**
 * @generated from message gitpod.v1.CreatePrebuildResponse
 */
export type CreatePrebuildResponse = Message<"gitpod.v1.CreatePrebuildResponse"> & {
  /**
   * @generated from field: gitpod.v1.Prebuild prebuild = 1;
   */
  prebuild?: Prebuild;
};

/**
 * Describes the message gitpod.v1.CreatePrebuildResponse.
 * Use `create(CreatePrebuildResponseSchema)` to create a new message.
 */
export const CreatePrebuildResponseSchema: GenMessage<CreatePrebuildResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_prebuild, 1);

/**
 * @generated from message gitpod.v1.ListPrebuildsRequest
 */
export type ListPrebuildsRequest = Message<"gitpod.v1.ListPrebuildsRequest"> & {
  /**
   * pagination contains the pagination options for listing prebuilds
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * filter contains the filter options for listing prebuilds
   *
   * @generated from field: gitpod.v1.ListPrebuildsRequest.Filter filter = 2;
   */
  filter?: ListPrebuildsRequest_Filter;
};

/**
 * Describes the message gitpod.v1.ListPrebuildsRequest.
 * Use `create(ListPrebuildsRequestSchema)` to create a new message.
 */
export const ListPrebuildsRequestSchema: GenMessage<ListPrebuildsRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_prebuild, 2);

/**
 * @generated from message gitpod.v1.ListPrebuildsRequest.Filter
 */
export type ListPrebuildsRequest_Filter = Message<"gitpod.v1.ListPrebuildsRequest.Filter"> & {
  /**
   * project_ids filters prebuilds to specific projects
   *
   * @generated from field: repeated string project_ids = 1;
   */
  projectIds: string[];

  /**
   * phases filters prebuilds by their current phase
   *
   * @generated from field: repeated gitpod.v1.PrebuildPhase phases = 2;
   */
  phases: PrebuildPhase[];

  /**
   * triggered_by filters prebuilds by how they were triggered
   *
   * @generated from field: repeated gitpod.v1.PrebuildMetadata.PrebuildTrigger triggered_by = 3;
   */
  triggeredBy: PrebuildMetadata_PrebuildTrigger[];

  /**
   * creator_ids filters prebuilds by who created them
   *
   * @generated from field: repeated string creator_ids = 4;
   */
  creatorIds: string[];

  /**
   * executor_ids filters prebuilds by whose credentials were used to run them
   *
   * @generated from field: repeated string executor_ids = 5;
   */
  executorIds: string[];
};

/**
 * Describes the message gitpod.v1.ListPrebuildsRequest.Filter.
 * Use `create(ListPrebuildsRequest_FilterSchema)` to create a new message.
 */
export const ListPrebuildsRequest_FilterSchema: GenMessage<ListPrebuildsRequest_Filter> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_prebuild, 2, 0);

/**
 * @generated from message gitpod.v1.ListPrebuildsResponse
 */
export type ListPrebuildsResponse = Message<"gitpod.v1.ListPrebuildsResponse"> & {
  /**
   * pagination contains the pagination response
   *
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * prebuilds are the prebuilds that matched the query
   *
   * @generated from field: repeated gitpod.v1.Prebuild prebuilds = 2;
   */
  prebuilds: Prebuild[];
};

/**
 * Describes the message gitpod.v1.ListPrebuildsResponse.
 * Use `create(ListPrebuildsResponseSchema)` to create a new message.
 */
export const ListPrebuildsResponseSchema: GenMessage<ListPrebuildsResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_prebuild, 3);

/**
 * @generated from message gitpod.v1.GetPrebuildRequest
 */
export type GetPrebuildRequest = Message<"gitpod.v1.GetPrebuildRequest"> & {
  /**
   * prebuild_id specifies the prebuild to retrieve
   *
   * @generated from field: string prebuild_id = 1;
   */
  prebuildId: string;
};

/**
 * Describes the message gitpod.v1.GetPrebuildRequest.
 * Use `create(GetPrebuildRequestSchema)` to create a new message.
 */
export const GetPrebuildRequestSchema: GenMessage<GetPrebuildRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_prebuild, 4);

/**
 * @generated from message gitpod.v1.GetPrebuildResponse
 */
export type GetPrebuildResponse = Message<"gitpod.v1.GetPrebuildResponse"> & {
  /**
   * @generated from field: gitpod.v1.Prebuild prebuild = 1;
   */
  prebuild?: Prebuild;
};

/**
 * Describes the message gitpod.v1.GetPrebuildResponse.
 * Use `create(GetPrebuildResponseSchema)` to create a new message.
 */
export const GetPrebuildResponseSchema: GenMessage<GetPrebuildResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_prebuild, 5);

/**
 * @generated from message gitpod.v1.CancelPrebuildRequest
 */
export type CancelPrebuildRequest = Message<"gitpod.v1.CancelPrebuildRequest"> & {
  /**
   * prebuild_id specifies the prebuild to cancel
   *
   * @generated from field: string prebuild_id = 1;
   */
  prebuildId: string;
};

/**
 * Describes the message gitpod.v1.CancelPrebuildRequest.
 * Use `create(CancelPrebuildRequestSchema)` to create a new message.
 */
export const CancelPrebuildRequestSchema: GenMessage<CancelPrebuildRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_prebuild, 6);

/**
 * @generated from message gitpod.v1.CancelPrebuildResponse
 */
export type CancelPrebuildResponse = Message<"gitpod.v1.CancelPrebuildResponse"> & {
  /**
   * @generated from field: gitpod.v1.Prebuild prebuild = 1;
   */
  prebuild?: Prebuild;
};

/**
 * Describes the message gitpod.v1.CancelPrebuildResponse.
 * Use `create(CancelPrebuildResponseSchema)` to create a new message.
 */
export const CancelPrebuildResponseSchema: GenMessage<CancelPrebuildResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_prebuild, 7);

/**
 * @generated from message gitpod.v1.DeletePrebuildRequest
 */
export type DeletePrebuildRequest = Message<"gitpod.v1.DeletePrebuildRequest"> & {
  /**
   * prebuild_id specifies the prebuild to delete
   *
   * @generated from field: string prebuild_id = 1;
   */
  prebuildId: string;
};

/**
 * Describes the message gitpod.v1.DeletePrebuildRequest.
 * Use `create(DeletePrebuildRequestSchema)` to create a new message.
 */
export const DeletePrebuildRequestSchema: GenMessage<DeletePrebuildRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_prebuild, 8);

/**
 * @generated from message gitpod.v1.DeletePrebuildResponse
 */
export type DeletePrebuildResponse = Message<"gitpod.v1.DeletePrebuildResponse"> & {
};

/**
 * Describes the message gitpod.v1.DeletePrebuildResponse.
 * Use `create(DeletePrebuildResponseSchema)` to create a new message.
 */
export const DeletePrebuildResponseSchema: GenMessage<DeletePrebuildResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_prebuild, 9);

/**
 * @generated from message gitpod.v1.CreatePrebuildLogsTokenRequest
 */
export type CreatePrebuildLogsTokenRequest = Message<"gitpod.v1.CreatePrebuildLogsTokenRequest"> & {
  /**
   * prebuild_id specifies the prebuild for which the logs token should be created.
   *
   * +required
   *
   * @generated from field: string prebuild_id = 1;
   */
  prebuildId: string;
};

/**
 * Describes the message gitpod.v1.CreatePrebuildLogsTokenRequest.
 * Use `create(CreatePrebuildLogsTokenRequestSchema)` to create a new message.
 */
export const CreatePrebuildLogsTokenRequestSchema: GenMessage<CreatePrebuildLogsTokenRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_prebuild, 10);

/**
 * @generated from message gitpod.v1.CreatePrebuildLogsTokenResponse
 */
export type CreatePrebuildLogsTokenResponse = Message<"gitpod.v1.CreatePrebuildLogsTokenResponse"> & {
  /**
   * access_token is the token that can be used to access the logs of the prebuild
   *
   * @generated from field: string access_token = 1;
   */
  accessToken: string;
};

/**
 * Describes the message gitpod.v1.CreatePrebuildLogsTokenResponse.
 * Use `create(CreatePrebuildLogsTokenResponseSchema)` to create a new message.
 */
export const CreatePrebuildLogsTokenResponseSchema: GenMessage<CreatePrebuildLogsTokenResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_prebuild, 11);

/**
 * Prebuild represents a prebuild for a project that creates a snapshot
 * for faster environment startup times.
 *
 * @generated from message gitpod.v1.Prebuild
 */
export type Prebuild = Message<"gitpod.v1.Prebuild"> & {
  /**
   * id is the unique identifier for the prebuild
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * metadata contains organizational and ownership information
   *
   * @generated from field: gitpod.v1.PrebuildMetadata metadata = 2;
   */
  metadata?: PrebuildMetadata;

  /**
   * spec contains the configuration used to create this prebuild
   *
   * @generated from field: gitpod.v1.PrebuildSpec spec = 3;
   */
  spec?: PrebuildSpec;

  /**
   * status contains the current status and progress of the prebuild
   *
   * @generated from field: gitpod.v1.PrebuildStatus status = 4;
   */
  status?: PrebuildStatus;
};

/**
 * Describes the message gitpod.v1.Prebuild.
 * Use `create(PrebuildSchema)` to create a new message.
 */
export const PrebuildSchema: GenMessage<Prebuild> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_prebuild, 12);

/**
 * PrebuildMetadata contains metadata about the prebuild
 *
 * @generated from message gitpod.v1.PrebuildMetadata
 */
export type PrebuildMetadata = Message<"gitpod.v1.PrebuildMetadata"> & {
  /**
   * organization_id is the ID of the organization that owns the prebuild
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * project_id is the ID of the project this prebuild was created for
   *
   * @generated from field: string project_id = 2;
   */
  projectId: string;

  /**
   * environment_class_id is the environment class used to create this prebuild.
   * While the prebuild is created with a specific environment class, environments
   * with different classes (e.g., smaller or larger instance sizes) can be created
   * from the same prebuild, as long as they run on the same runner.
   * If not specified in create requests, uses the project's default environment class.
   *
   * @generated from field: string environment_class_id = 3;
   */
  environmentClassId: string;

  /**
   * creator is the identity of who created the prebuild.
   * For manual prebuilds, this is the user who triggered it.
   * For scheduled prebuilds, this is the configured executor.
   *
   * @generated from field: gitpod.v1.Subject creator = 4;
   */
  creator?: Subject;

  /**
   * created_at is when the prebuild was created
   *
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * updated_at is when the prebuild was last updated
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp;

  /**
   * trigger describes the trigger that created this prebuild.
   *
   * @generated from field: gitpod.v1.PrebuildMetadata.PrebuildTrigger triggered_by = 7;
   */
  triggeredBy: PrebuildMetadata_PrebuildTrigger;

  /**
   * executor is the identity used to run the prebuild.
   * The executor's SCM credentials are used to clone the repository.
   * If not set, the creator's identity is used.
   *
   * @generated from field: gitpod.v1.Subject executor = 8;
   */
  executor?: Subject;
};

/**
 * Describes the message gitpod.v1.PrebuildMetadata.
 * Use `create(PrebuildMetadataSchema)` to create a new message.
 */
export const PrebuildMetadataSchema: GenMessage<PrebuildMetadata> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_prebuild, 13);

/**
 * PrebuildTrigger indicates how the prebuild was triggered
 *
 * @generated from enum gitpod.v1.PrebuildMetadata.PrebuildTrigger
 */
export enum PrebuildMetadata_PrebuildTrigger {
  /**
   * PREBUILD_TRIGGER_UNSPECIFIED is the default value and should not be used
   *
   * @generated from enum value: PREBUILD_TRIGGER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * PREBUILD_TRIGGER_MANUAL indicates the prebuild was manually triggered by a user
   *
   * @generated from enum value: PREBUILD_TRIGGER_MANUAL = 1;
   */
  MANUAL = 1,

  /**
   * PREBUILD_TRIGGER_SCHEDULED indicates the prebuild was triggered by a scheduled job
   *
   * @generated from enum value: PREBUILD_TRIGGER_SCHEDULED = 2;
   */
  SCHEDULED = 2,
}

/**
 * Describes the enum gitpod.v1.PrebuildMetadata.PrebuildTrigger.
 */
export const PrebuildMetadata_PrebuildTriggerSchema: GenEnum<PrebuildMetadata_PrebuildTrigger> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_prebuild, 13, 0);

/**
 * PrebuildSpec contains the configuration used to create a prebuild
 *
 * @generated from message gitpod.v1.PrebuildSpec
 */
export type PrebuildSpec = Message<"gitpod.v1.PrebuildSpec"> & {
  /**
   * spec_version is incremented each time the spec is updated.
   * Used for optimistic concurrency control.
   *
   * @generated from field: uint64 spec_version = 1;
   */
  specVersion: bigint;

  /**
   * desired_phase is the desired phase of the prebuild.
   * Used to signal cancellation or other state changes.
   * This field is managed by the API and reconciler.
   *
   * @generated from field: gitpod.v1.PrebuildPhase desired_phase = 2;
   */
  desiredPhase: PrebuildPhase;

  /**
   * timeout is the maximum time allowed for the prebuild to complete.
   * Defaults to 60 minutes if not specified.
   * Maximum allowed timeout is 2 hours.
   *
   * @generated from field: google.protobuf.Duration timeout = 3;
   */
  timeout?: Duration;
};

/**
 * Describes the message gitpod.v1.PrebuildSpec.
 * Use `create(PrebuildSpecSchema)` to create a new message.
 */
export const PrebuildSpecSchema: GenMessage<PrebuildSpec> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_prebuild, 14);

/**
 * PrebuildStatus contains the current status and progress of a prebuild
 *
 * @generated from message gitpod.v1.PrebuildStatus
 */
export type PrebuildStatus = Message<"gitpod.v1.PrebuildStatus"> & {
  /**
   * phase is the current phase of the prebuild lifecycle
   *
   * @generated from field: gitpod.v1.PrebuildPhase phase = 1;
   */
  phase: PrebuildPhase;

  /**
   * completion_time is when the prebuild completed (successfully or with failure)
   *
   * @generated from field: google.protobuf.Timestamp completion_time = 2;
   */
  completionTime?: Timestamp;

  /**
   * failure_message contains details about why the prebuild failed
   *
   * @generated from field: string failure_message = 3;
   */
  failureMessage: string;

  /**
   * log_url provides access to prebuild logs.
   * During prebuild execution, this references the environment logs.
   * After completion, this may reference archived logs.
   *
   * @generated from field: string log_url = 4;
   */
  logUrl: string;

  /**
   * environment_id is the ID of the environment used to create this prebuild.
   * This field is set when the prebuild environment is created.
   *
   * @generated from field: string environment_id = 5;
   */
  environmentId: string;

  /**
   * status_version is incremented each time the status is updated.
   * Used for optimistic concurrency control.
   *
   * @generated from field: uint64 status_version = 6;
   */
  statusVersion: bigint;

  /**
   * warning_message contains warnings from the prebuild environment that indicate something went wrong
   * but the prebuild could still complete. For example, the devcontainer failed to build but the environment
   * is still usable. These warnings will likely affect any environment started from this prebuild.
   *
   * @generated from field: string warning_message = 7;
   */
  warningMessage: string;

  /**
   * snapshot_completion_percentage is the progress of snapshot creation (0-100).
   * Only populated when phase is SNAPSHOTTING and progress is available from the cloud provider.
   * This value may update infrequently or remain at 0 depending on the provider.
   *
   * @generated from field: int32 snapshot_completion_percentage = 8;
   */
  snapshotCompletionPercentage: number;

  /**
   * snapshot_size_bytes is the size of the snapshot in bytes.
   * Only populated when the snapshot is available (phase is COMPLETED).
   *
   * @generated from field: int64 snapshot_size_bytes = 9;
   */
  snapshotSizeBytes: bigint;
};

/**
 * Describes the message gitpod.v1.PrebuildStatus.
 * Use `create(PrebuildStatusSchema)` to create a new message.
 */
export const PrebuildStatusSchema: GenMessage<PrebuildStatus> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_prebuild, 15);

/**
 * @generated from message gitpod.v1.CreateWarmPoolRequest
 */
export type CreateWarmPoolRequest = Message<"gitpod.v1.CreateWarmPoolRequest"> & {
  /**
   * project_id specifies the project this warm pool belongs to.
   * The project must have prebuilds enabled.
   *
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * environment_class_id specifies which environment class to warm.
   * Must be listed in the project's prebuild configuration environment_class_ids.
   *
   * @generated from field: string environment_class_id = 2;
   */
  environmentClassId: string;

  /**
   * desired_size is the number of warm instances to maintain.
   * Deprecated: Use min_size and max_size instead for dynamic scaling.
   *
   * @generated from field: int32 desired_size = 3 [deprecated = true];
   * @deprecated
   */
  desiredSize: number;

  /**
   * min_size is the minimum number of warm instances to maintain.
   * The pool will never scale below this value.
   * Must be >= 0 and <= max_size. Set to 0 to allow full scale-down.
   *
   * @generated from field: optional int32 min_size = 4;
   */
  minSize?: number;

  /**
   * max_size is the maximum number of warm instances to maintain.
   * The pool will never scale above this value.
   * Must be >= min_size and <= 20.
   *
   * @generated from field: optional int32 max_size = 5;
   */
  maxSize?: number;
};

/**
 * Describes the message gitpod.v1.CreateWarmPoolRequest.
 * Use `create(CreateWarmPoolRequestSchema)` to create a new message.
 */
export const CreateWarmPoolRequestSchema: GenMessage<CreateWarmPoolRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_prebuild, 16);

/**
 * @generated from message gitpod.v1.CreateWarmPoolResponse
 */
export type CreateWarmPoolResponse = Message<"gitpod.v1.CreateWarmPoolResponse"> & {
  /**
   * @generated from field: gitpod.v1.WarmPool warm_pool = 1;
   */
  warmPool?: WarmPool;
};

/**
 * Describes the message gitpod.v1.CreateWarmPoolResponse.
 * Use `create(CreateWarmPoolResponseSchema)` to create a new message.
 */
export const CreateWarmPoolResponseSchema: GenMessage<CreateWarmPoolResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_prebuild, 17);

/**
 * @generated from message gitpod.v1.GetWarmPoolRequest
 */
export type GetWarmPoolRequest = Message<"gitpod.v1.GetWarmPoolRequest"> & {
  /**
   * warm_pool_id specifies the warm pool to retrieve
   *
   * @generated from field: string warm_pool_id = 1;
   */
  warmPoolId: string;
};

/**
 * Describes the message gitpod.v1.GetWarmPoolRequest.
 * Use `create(GetWarmPoolRequestSchema)` to create a new message.
 */
export const GetWarmPoolRequestSchema: GenMessage<GetWarmPoolRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_prebuild, 18);

/**
 * @generated from message gitpod.v1.GetWarmPoolResponse
 */
export type GetWarmPoolResponse = Message<"gitpod.v1.GetWarmPoolResponse"> & {
  /**
   * @generated from field: gitpod.v1.WarmPool warm_pool = 1;
   */
  warmPool?: WarmPool;
};

/**
 * Describes the message gitpod.v1.GetWarmPoolResponse.
 * Use `create(GetWarmPoolResponseSchema)` to create a new message.
 */
export const GetWarmPoolResponseSchema: GenMessage<GetWarmPoolResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_prebuild, 19);

/**
 * @generated from message gitpod.v1.ListWarmPoolsRequest
 */
export type ListWarmPoolsRequest = Message<"gitpod.v1.ListWarmPoolsRequest"> & {
  /**
   * pagination contains the pagination options for listing warm pools
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * filter contains the filter options for listing warm pools
   *
   * @generated from field: gitpod.v1.ListWarmPoolsRequest.Filter filter = 2;
   */
  filter?: ListWarmPoolsRequest_Filter;
};

/**
 * Describes the message gitpod.v1.ListWarmPoolsRequest.
 * Use `create(ListWarmPoolsRequestSchema)` to create a new message.
 */
export const ListWarmPoolsRequestSchema: GenMessage<ListWarmPoolsRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_prebuild, 20);

/**
 * @generated from message gitpod.v1.ListWarmPoolsRequest.Filter
 */
export type ListWarmPoolsRequest_Filter = Message<"gitpod.v1.ListWarmPoolsRequest.Filter"> & {
  /**
   * project_ids filters warm pools to specific projects
   *
   * @generated from field: repeated string project_ids = 1;
   */
  projectIds: string[];

  /**
   * environment_class_ids filters warm pools to specific environment classes
   *
   * @generated from field: repeated string environment_class_ids = 2;
   */
  environmentClassIds: string[];
};

/**
 * Describes the message gitpod.v1.ListWarmPoolsRequest.Filter.
 * Use `create(ListWarmPoolsRequest_FilterSchema)` to create a new message.
 */
export const ListWarmPoolsRequest_FilterSchema: GenMessage<ListWarmPoolsRequest_Filter> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_prebuild, 20, 0);

/**
 * @generated from message gitpod.v1.ListWarmPoolsResponse
 */
export type ListWarmPoolsResponse = Message<"gitpod.v1.ListWarmPoolsResponse"> & {
  /**
   * pagination contains the pagination response
   *
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * warm_pools are the warm pools that matched the query
   *
   * @generated from field: repeated gitpod.v1.WarmPool warm_pools = 2;
   */
  warmPools: WarmPool[];
};

/**
 * Describes the message gitpod.v1.ListWarmPoolsResponse.
 * Use `create(ListWarmPoolsResponseSchema)` to create a new message.
 */
export const ListWarmPoolsResponseSchema: GenMessage<ListWarmPoolsResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_prebuild, 21);

/**
 * @generated from message gitpod.v1.UpdateWarmPoolRequest
 */
export type UpdateWarmPoolRequest = Message<"gitpod.v1.UpdateWarmPoolRequest"> & {
  /**
   * warm_pool_id specifies the warm pool to update
   *
   * @generated from field: string warm_pool_id = 1;
   */
  warmPoolId: string;

  /**
   * desired_size updates the number of warm instances to maintain.
   * Deprecated: Use min_size and max_size instead for dynamic scaling.
   *
   * @generated from field: optional int32 desired_size = 2 [deprecated = true];
   * @deprecated
   */
  desiredSize?: number;

  /**
   * min_size updates the minimum number of warm instances to maintain.
   * The pool will never scale below this value.
   * Must be >= 0 and <= max_size. Set to 0 to allow full scale-down.
   *
   * @generated from field: optional int32 min_size = 3;
   */
  minSize?: number;

  /**
   * max_size updates the maximum number of warm instances to maintain.
   * The pool will never scale above this value.
   * Must be >= min_size and <= 20.
   *
   * @generated from field: optional int32 max_size = 4;
   */
  maxSize?: number;
};

/**
 * Describes the message gitpod.v1.UpdateWarmPoolRequest.
 * Use `create(UpdateWarmPoolRequestSchema)` to create a new message.
 */
export const UpdateWarmPoolRequestSchema: GenMessage<UpdateWarmPoolRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_prebuild, 22);

/**
 * @generated from message gitpod.v1.UpdateWarmPoolResponse
 */
export type UpdateWarmPoolResponse = Message<"gitpod.v1.UpdateWarmPoolResponse"> & {
  /**
   * @generated from field: gitpod.v1.WarmPool warm_pool = 1;
   */
  warmPool?: WarmPool;
};

/**
 * Describes the message gitpod.v1.UpdateWarmPoolResponse.
 * Use `create(UpdateWarmPoolResponseSchema)` to create a new message.
 */
export const UpdateWarmPoolResponseSchema: GenMessage<UpdateWarmPoolResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_prebuild, 23);

/**
 * @generated from message gitpod.v1.DeleteWarmPoolRequest
 */
export type DeleteWarmPoolRequest = Message<"gitpod.v1.DeleteWarmPoolRequest"> & {
  /**
   * warm_pool_id specifies the warm pool to delete
   *
   * @generated from field: string warm_pool_id = 1;
   */
  warmPoolId: string;
};

/**
 * Describes the message gitpod.v1.DeleteWarmPoolRequest.
 * Use `create(DeleteWarmPoolRequestSchema)` to create a new message.
 */
export const DeleteWarmPoolRequestSchema: GenMessage<DeleteWarmPoolRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_prebuild, 24);

/**
 * @generated from message gitpod.v1.DeleteWarmPoolResponse
 */
export type DeleteWarmPoolResponse = Message<"gitpod.v1.DeleteWarmPoolResponse"> & {
};

/**
 * Describes the message gitpod.v1.DeleteWarmPoolResponse.
 * Use `create(DeleteWarmPoolResponseSchema)` to create a new message.
 */
export const DeleteWarmPoolResponseSchema: GenMessage<DeleteWarmPoolResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_prebuild, 25);

/**
 * WarmPool maintains pre-created environment instances from a prebuild snapshot
 * for near-instant environment startup.
 * One warm pool exists per <project, environment_class> pair.
 *
 * @generated from message gitpod.v1.WarmPool
 */
export type WarmPool = Message<"gitpod.v1.WarmPool"> & {
  /**
   * id is the unique identifier for the warm pool
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * metadata contains organizational and ownership information
   *
   * @generated from field: gitpod.v1.WarmPoolMetadata metadata = 2;
   */
  metadata?: WarmPoolMetadata;

  /**
   * spec contains the desired configuration for this warm pool
   *
   * @generated from field: gitpod.v1.WarmPoolSpec spec = 3;
   */
  spec?: WarmPoolSpec;

  /**
   * status contains the current status reported by the runner
   *
   * @generated from field: gitpod.v1.WarmPoolStatus status = 4;
   */
  status?: WarmPoolStatus;
};

/**
 * Describes the message gitpod.v1.WarmPool.
 * Use `create(WarmPoolSchema)` to create a new message.
 */
export const WarmPoolSchema: GenMessage<WarmPool> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_prebuild, 26);

/**
 * WarmPoolMetadata contains metadata about the warm pool
 *
 * @generated from message gitpod.v1.WarmPoolMetadata
 */
export type WarmPoolMetadata = Message<"gitpod.v1.WarmPoolMetadata"> & {
  /**
   * organization_id is the ID of the organization that owns the warm pool
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * project_id is the ID of the project this warm pool belongs to
   *
   * @generated from field: string project_id = 2;
   */
  projectId: string;

  /**
   * environment_class_id is the environment class whose instances are warmed
   *
   * @generated from field: string environment_class_id = 3;
   */
  environmentClassId: string;

  /**
   * runner_id is the runner that manages this warm pool.
   * Derived from the environment class.
   *
   * @generated from field: string runner_id = 4;
   */
  runnerId: string;

  /**
   * created_at is when the warm pool was created
   *
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * updated_at is when the warm pool was last updated
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message gitpod.v1.WarmPoolMetadata.
 * Use `create(WarmPoolMetadataSchema)` to create a new message.
 */
export const WarmPoolMetadataSchema: GenMessage<WarmPoolMetadata> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_prebuild, 27);

/**
 * WarmPoolSpec contains the desired configuration for a warm pool
 *
 * @generated from message gitpod.v1.WarmPoolSpec
 */
export type WarmPoolSpec = Message<"gitpod.v1.WarmPoolSpec"> & {
  /**
   * spec_version is incremented each time the spec is updated.
   * Used for optimistic concurrency control.
   *
   * @generated from field: uint64 spec_version = 1;
   */
  specVersion: bigint;

  /**
   * desired_size is the number of warm instances to maintain.
   * Deprecated: Use min_size and max_size instead for dynamic scaling.
   * Existing pools will be migrated to min_size=max_size=desired_size.
   *
   * @generated from field: int32 desired_size = 2 [deprecated = true];
   * @deprecated
   */
  desiredSize: number;

  /**
   * snapshot_id is the prebuild snapshot to warm up in the pool.
   * Updated by the reconciler when a new prebuild completes for this
   * project and environment class. Empty when no completed prebuild exists yet.
   *
   * @generated from field: optional string snapshot_id = 3;
   */
  snapshotId?: string;

  /**
   * desired_phase is the intended lifecycle phase for this warm pool.
   * Managed by the API and reconciler.
   *
   * @generated from field: gitpod.v1.WarmPoolPhase desired_phase = 4;
   */
  desiredPhase: WarmPoolPhase;

  /**
   * min_size is the minimum number of warm instances to maintain.
   * The pool will never scale below this value.
   * Must be >= 0 and <= max_size. Set to 0 to allow full scale-down.
   *
   * @generated from field: optional int32 min_size = 5;
   */
  minSize?: number;

  /**
   * max_size is the maximum number of warm instances to maintain.
   * The pool will never scale above this value.
   * Must be >= min_size and <= 20.
   *
   * @generated from field: optional int32 max_size = 6;
   */
  maxSize?: number;
};

/**
 * Describes the message gitpod.v1.WarmPoolSpec.
 * Use `create(WarmPoolSpecSchema)` to create a new message.
 */
export const WarmPoolSpecSchema: GenMessage<WarmPoolSpec> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_prebuild, 28);

/**
 * WarmPoolStatus contains the current status of a warm pool as reported by the runner
 *
 * @generated from message gitpod.v1.WarmPoolStatus
 */
export type WarmPoolStatus = Message<"gitpod.v1.WarmPoolStatus"> & {
  /**
   * phase is the current phase of the warm pool lifecycle
   *
   * @generated from field: gitpod.v1.WarmPoolPhase phase = 1;
   */
  phase: WarmPoolPhase;

  /**
   * failure_message contains details about why the warm pool is degraded or failed
   *
   * @generated from field: string failure_message = 2;
   */
  failureMessage: string;

  /**
   * status_version is incremented each time the status is updated.
   * Used for optimistic concurrency control.
   *
   * @generated from field: uint64 status_version = 3;
   */
  statusVersion: bigint;

  /**
   * running_instances is the number of running warm instances in the pool,
   * ready to be claimed for near-instant environment startup.
   *
   * @generated from field: int32 running_instances = 4;
   */
  runningInstances: number;

  /**
   * stopped_instances is the number of pre-provisioned but stopped instances
   * in the pool. When a running instance is claimed, stopped instances are
   * used to backfill the running pool faster than provisioning from scratch.
   * Stopped instances only incur storage costs, allowing a larger total pool
   * at lower cost than keeping all instances running.
   *
   * @generated from field: int32 stopped_instances = 5;
   */
  stoppedInstances: number;

  /**
   * desired_size is the current target number of instances the autoscaler
   * has decided on. Unlike running_instances, this value is stable and
   * does not fluctuate as instances are claimed and backfilled.
   *
   * @generated from field: int32 desired_size = 6;
   */
  desiredSize: number;
};

/**
 * Describes the message gitpod.v1.WarmPoolStatus.
 * Use `create(WarmPoolStatusSchema)` to create a new message.
 */
export const WarmPoolStatusSchema: GenMessage<WarmPoolStatus> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_prebuild, 29);

/**
 * PrebuildPhase represents the lifecycle phase of a prebuild
 *
 * @generated from enum gitpod.v1.PrebuildPhase
 */
export enum PrebuildPhase {
  /**
   * PREBUILD_PHASE_UNSPECIFIED is the default value and should not be used
   *
   * @generated from enum value: PREBUILD_PHASE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * PREBUILD_PHASE_PENDING indicates the prebuild has been created but the environment has not yet started
   *
   * @generated from enum value: PREBUILD_PHASE_PENDING = 10;
   */
  PENDING = 10,

  /**
   * PREBUILD_PHASE_STARTING indicates the prebuild is being started
   *
   * @generated from enum value: PREBUILD_PHASE_STARTING = 20;
   */
  STARTING = 20,

  /**
   * PREBUILD_PHASE_RUNNING indicates the prebuild is running and tasks are executing
   *
   * @generated from enum value: PREBUILD_PHASE_RUNNING = 30;
   */
  RUNNING = 30,

  /**
   * PREBUILD_PHASE_STOPPING indicates the prebuild is being stopped after completion
   *
   * @generated from enum value: PREBUILD_PHASE_STOPPING = 40;
   */
  STOPPING = 40,

  /**
   * PREBUILD_PHASE_SNAPSHOTTING indicates the environment has stopped and a snapshot is being created
   *
   * @generated from enum value: PREBUILD_PHASE_SNAPSHOTTING = 50;
   */
  SNAPSHOTTING = 50,

  /**
   * PREBUILD_PHASE_COMPLETED indicates the prebuild completed successfully and the snapshot is available
   *
   * @generated from enum value: PREBUILD_PHASE_COMPLETED = 60;
   */
  COMPLETED = 60,

  /**
   * PREBUILD_PHASE_FAILED indicates the prebuild failed at any stage
   *
   * @generated from enum value: PREBUILD_PHASE_FAILED = 70;
   */
  FAILED = 70,

  /**
   * PREBUILD_PHASE_CANCELLING indicates the prebuild is being cancelled (cleanup in progress)
   *
   * @generated from enum value: PREBUILD_PHASE_CANCELLING = 75;
   */
  CANCELLING = 75,

  /**
   * PREBUILD_PHASE_CANCELLED indicates the prebuild was manually cancelled
   *
   * @generated from enum value: PREBUILD_PHASE_CANCELLED = 80;
   */
  CANCELLED = 80,

  /**
   * PREBUILD_PHASE_DELETING indicates the prebuild is being deleted (cleanup in progress)
   *
   * @generated from enum value: PREBUILD_PHASE_DELETING = 85;
   */
  DELETING = 85,

  /**
   * PREBUILD_PHASE_DELETED indicates the prebuild is being deleted
   *
   * @generated from enum value: PREBUILD_PHASE_DELETED = 90;
   */
  DELETED = 90,
}

/**
 * Describes the enum gitpod.v1.PrebuildPhase.
 */
export const PrebuildPhaseSchema: GenEnum<PrebuildPhase> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_prebuild, 0);

/**
 * WarmPoolPhase represents the lifecycle phase of a warm pool
 *
 * @generated from enum gitpod.v1.WarmPoolPhase
 */
export enum WarmPoolPhase {
  /**
   * WARM_POOL_PHASE_UNSPECIFIED is the default value and should not be used
   *
   * @generated from enum value: WARM_POOL_PHASE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * WARM_POOL_PHASE_PENDING indicates the warm pool has been created but no snapshot is assigned yet
   *
   * @generated from enum value: WARM_POOL_PHASE_PENDING = 10;
   */
  PENDING = 10,

  /**
   * WARM_POOL_PHASE_READY indicates the runner has acknowledged the pool and instances are available
   *
   * @generated from enum value: WARM_POOL_PHASE_READY = 20;
   */
  READY = 20,

  /**
   * WARM_POOL_PHASE_DEGRADED indicates the runner reported a problem with the pool
   *
   * @generated from enum value: WARM_POOL_PHASE_DEGRADED = 30;
   */
  DEGRADED = 30,

  /**
   * WARM_POOL_PHASE_DELETING indicates the warm pool is being deleted and instances are draining
   *
   * @generated from enum value: WARM_POOL_PHASE_DELETING = 40;
   */
  DELETING = 40,

  /**
   * WARM_POOL_PHASE_DELETED indicates the warm pool has been fully cleaned up
   *
   * @generated from enum value: WARM_POOL_PHASE_DELETED = 50;
   */
  DELETED = 50,
}

/**
 * Describes the enum gitpod.v1.WarmPoolPhase.
 */
export const WarmPoolPhaseSchema: GenEnum<WarmPoolPhase> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_prebuild, 1);

/**
 * PrebuildService manages prebuilds for projects to enable faster environment startup times.
 * Prebuilds create snapshots of environments that can be used to provision new environments quickly.
 *
 * @generated from service gitpod.v1.PrebuildService
 */
export const PrebuildService: GenService<{
  /**
   * Creates a prebuild for a project.
   *
   * Use this method to:
   * - Create on-demand prebuilds for faster environment startup
   * - Trigger prebuilds after repository changes
   * - Generate prebuilds for specific environment classes
   *
   * The prebuild process creates an environment, runs the devcontainer prebuild lifecycle,
   * and creates a snapshot for future environment provisioning.
   *
   * ### Examples
   *
   * - Create basic prebuild:
   *
   *   Creates a prebuild for a project using default settings.
   *
   *   ```yaml
   *   projectId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   spec:
   *     timeout: "3600s"  # 60 minutes default
   *   ```
   *
   * - Create prebuild with custom environment class:
   *
   *   Creates a prebuild with a specific environment class and timeout.
   *
   *   ```yaml
   *   projectId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   environmentClassId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   spec:
   *     timeout: "3600s"  # 1 hour
   *   ```
   *
   * @generated from rpc gitpod.v1.PrebuildService.CreatePrebuild
   */
  createPrebuild: {
    methodKind: "unary";
    input: typeof CreatePrebuildRequestSchema;
    output: typeof CreatePrebuildResponseSchema;
  },
  /**
   * @generated from rpc gitpod.v1.PrebuildService.ListPrebuilds
   */
  listPrebuilds: {
    methodKind: "unary";
    input: typeof ListPrebuildsRequestSchema;
    output: typeof ListPrebuildsResponseSchema;
  },
  /**
   * Gets details about a specific prebuild.
   *
   * Use this method to:
   * - Check prebuild status and progress
   * - Access prebuild logs for debugging
   *
   * ### Examples
   *
   * - Get prebuild details:
   *
   *   Retrieves comprehensive information about a prebuild.
   *
   *   ```yaml
   *   prebuildId: "07e03a28-65a5-4d98-b532-8ea67b188048"
   *   ```
   *
   * @generated from rpc gitpod.v1.PrebuildService.GetPrebuild
   */
  getPrebuild: {
    methodKind: "unary";
    input: typeof GetPrebuildRequestSchema;
    output: typeof GetPrebuildResponseSchema;
  },
  /**
   * Cancels a running prebuild.
   *
   * Use this method to:
   * - Stop prebuilds that are no longer needed
   * - Free up resources for other operations
   *
   * ### Examples
   *
   * - Cancel prebuild:
   *
   *   Stops a running prebuild and cleans up resources.
   *
   *   ```yaml
   *   prebuildId: "07e03a28-65a5-4d98-b532-8ea67b188048"
   *   ```
   *
   * @generated from rpc gitpod.v1.PrebuildService.CancelPrebuild
   */
  cancelPrebuild: {
    methodKind: "unary";
    input: typeof CancelPrebuildRequestSchema;
    output: typeof CancelPrebuildResponseSchema;
  },
  /**
   * Deletes a prebuild.
   *
   * Prebuilds are automatically deleted after some time. Use this method to
   * manually delete a prebuild before automatic cleanup, for example to remove
   * a prebuild that should no longer be used.
   *
   * Deletion is processed asynchronously. The prebuild will be marked for deletion
   * and removed from the system in the background.
   *
   * ### Examples
   *
   * - Delete prebuild:
   *
   *   Marks a prebuild for deletion and removes it from the system.
   *
   *   ```yaml
   *   prebuildId: "07e03a28-65a5-4d98-b532-8ea67b188048"
   *   ```
   *
   * @generated from rpc gitpod.v1.PrebuildService.DeletePrebuild
   */
  deletePrebuild: {
    methodKind: "unary";
    input: typeof DeletePrebuildRequestSchema;
    output: typeof DeletePrebuildResponseSchema;
  },
  /**
   * Creates a logs access token for a prebuild.
   *
   * Use this method to:
   * - Stream logs from a running prebuild
   * - Access archived logs from completed prebuilds
   *
   * Generated tokens are valid for one hour.
   *
   * ### Examples
   *
   * - Create prebuild logs token:
   *
   *   Generates a token for accessing prebuild logs.
   *
   *   ```yaml
   *   prebuildId: "07e03a28-65a5-4d98-b532-8ea67b188048"
   *   ```
   *
   * @generated from rpc gitpod.v1.PrebuildService.CreatePrebuildLogsToken
   */
  createPrebuildLogsToken: {
    methodKind: "unary";
    input: typeof CreatePrebuildLogsTokenRequestSchema;
    output: typeof CreatePrebuildLogsTokenResponseSchema;
  },
  /**
   * Creates a warm pool for a project and environment class.
   *
   * A warm pool maintains pre-created environment instances from a prebuild snapshot
   * so that new environments can start near-instantly.
   *
   * Only one warm pool is allowed per <project, environment_class> pair.
   * The environment class must have prebuilds enabled on the project.
   *
   * The pool's snapshot is managed automatically: when a new prebuild completes
   * for the same project and environment class, the pool's snapshot is updated
   * and the runner rotates instances.
   *
   * ### Examples
   *
   * - Create warm pool:
   *
   *   Creates a warm pool with 2 instances for a project and environment class.
   *
   *   ```yaml
   *   projectId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   environmentClassId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   desiredSize: 2
   *   ```
   *
   * @generated from rpc gitpod.v1.PrebuildService.CreateWarmPool
   */
  createWarmPool: {
    methodKind: "unary";
    input: typeof CreateWarmPoolRequestSchema;
    output: typeof CreateWarmPoolResponseSchema;
  },
  /**
   * Gets details about a specific warm pool.
   *
   * Use this method to:
   * - Check warm pool status and phase
   * - View the current snapshot being warmed
   * - Monitor pool health
   *
   * ### Examples
   *
   * - Get warm pool:
   *
   *   ```yaml
   *   warmPoolId: "a1b2c3d4-5678-9abc-def0-1234567890ab"
   *   ```
   *
   * @generated from rpc gitpod.v1.PrebuildService.GetWarmPool
   */
  getWarmPool: {
    methodKind: "unary";
    input: typeof GetWarmPoolRequestSchema;
    output: typeof GetWarmPoolResponseSchema;
  },
  /**
   * Lists warm pools with optional filtering.
   *
   * Use this method to:
   * - View all warm pools for a project
   * - Monitor warm pool status across environment classes
   *
   * ### Examples
   *
   * - List warm pools for a project:
   *
   *   ```yaml
   *   filter:
   *     projectIds: ["b0e12f6c-4c67-429d-a4a6-d9838b5da047"]
   *   ```
   *
   * @generated from rpc gitpod.v1.PrebuildService.ListWarmPools
   */
  listWarmPools: {
    methodKind: "unary";
    input: typeof ListWarmPoolsRequestSchema;
    output: typeof ListWarmPoolsResponseSchema;
  },
  /**
   * Updates a warm pool's configuration.
   *
   * Use this method to change the desired pool size.
   *
   * ### Examples
   *
   * - Update pool size:
   *
   *   ```yaml
   *   warmPoolId: "a1b2c3d4-5678-9abc-def0-1234567890ab"
   *   desiredSize: 5
   *   ```
   *
   * @generated from rpc gitpod.v1.PrebuildService.UpdateWarmPool
   */
  updateWarmPool: {
    methodKind: "unary";
    input: typeof UpdateWarmPoolRequestSchema;
    output: typeof UpdateWarmPoolResponseSchema;
  },
  /**
   * Deletes a warm pool.
   *
   * Deletion is processed asynchronously. The pool is marked for deletion
   * and the runner drains instances in the background.
   *
   * Warm pools are also automatically deleted when prebuilds are disabled
   * on the project or the environment class is removed from the prebuild
   * configuration.
   *
   * ### Examples
   *
   * - Delete warm pool:
   *
   *   ```yaml
   *   warmPoolId: "a1b2c3d4-5678-9abc-def0-1234567890ab"
   *   ```
   *
   * @generated from rpc gitpod.v1.PrebuildService.DeleteWarmPool
   */
  deleteWarmPool: {
    methodKind: "unary";
    input: typeof DeleteWarmPoolRequestSchema;
    output: typeof DeleteWarmPoolResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_gitpod_v1_prebuild, 0);

